module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"company":"Company","technology":"Technology","news":"News","back":"back"},"fr":{"company":"Entreprise","technology":"Technologie","news":"Actualités","back":"retour"}}')
  delete Component.options._Ctor
}
